<template>
  <div class="auth-page">
    <b-container>
      <h5 class="auth-logo">
        <i class="fa fa-circle text-primary"></i>
        Ekhoni Daktar
        <i class="fa fa-circle text-danger"></i>
      </h5>
      <Widget class="widget-auth mx-auto" title="<h3 class='mt-0'>Login as General User</h3>" customHeader>
        <p class="widget-auth-info">
          Use your mobile number to sign in.
        </p>
        <form class="mt" @submit.prevent="login">
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
            {{ errorMessage }}
          </b-alert>
          <div class="form-group">
            <b-form-input class="form-control no-border" v-model="login_form.mobile" ref="mobile" required type="tel"
                          name="mobile" placeholder="Phone Number" :disabled="otp_code_requested"/>
          </div>
          <div v-if="otp_code_requested" class="form-group">
            <b-form-input class="form-control no-border" v-model="login_form.otp_code" ref="otp_code" required
                          type="number" name="otp_code" placeholder="OTP Code"/>
          </div>

          <b-button size="sm" class="auth-btn mb-3" variant="inverse"
                    @click="(otp_code_requested)? requestLogin(): getOtp()">
            {{ (otp_code_requested) ? 'Login' : 'Get OTP' }}
          </b-button>
          <!--          <p class="widget-auth-info">or sign in with</p>-->
          <!--          <div class="social-buttons">-->
          <!--            <b-button variant="primary" class="social-button mb-2">-->
          <!--              <i class="social-icon social-google"></i>-->
          <!--              <p class="social-text">GOOGLE</p>-->
          <!--            </b-button>-->
          <!--            <b-button variant="success" class="social-button">-->
          <!--              <i class="social-icon social-microsoft"></i>-->
          <!--              <p class="social-text">MICROSOFT</p>-->
          <!--            </b-button>-->
          <!--          </div>-->
        </form>
        <p class="widget-auth-info">
          Don't have an account? Sign up now!
        </p>
        <router-link class="d-block text-center" to="login">Create an Account</router-link>
      </Widget>
    </b-container>
  </div>
</template>

<script>
import Form from 'vform';

import AuthService from '@/services/general_user/auth.service';
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'LoginPage',
  data() {
    return {
      errorMessage: null,
      otp_code_requested: false,
      login_form: new Form({
        mobile: '',
        otp_code: '',
        device_first_login: false,
        is_patient: true,
        device_id: null,
      }),
    };
  },
  computed: {
    ...mapGetters('generalUserAuth', ['getUser']),
  },
  methods: {
    ...mapActions('generalUserAuth', ['storeUser']),
    requestLogin() {
      AuthService.login(this.login_form)
          .then((resposne) => {
            if (resposne.status === 200 || resposne.status === 201) {
              this.storeUser(resposne.data);
              this.$router.push('/home');
            }
          })
    },
    getOtp() {
      AuthService.requestOTP(this.login_form)
          .then((response) => {
            if (response.status === 201) {
              this.otp_code_requested = true;
            }
          })
          .catch((e) => console.error(e))
    }
  },
  created() {
    if (this.getUser) {
      this.$router.push('/home');
    }
  },
};
</script>
